import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';
import { native } from './platform/native';

declare global {
  interface Window {
    __cdSplashDone?: () => void;
  }
}

// Boot Capacitor plugins early so haptics / status-bar / splash are ready by
// the time React mounts. No-op on web.
void native.init().then(() => {
  native.styleStatusBar();
});

const rootEl = document.getElementById('root')!;
// StrictMode is intentionally disabled: it double-mounts effects in dev, and
// PixiCanvas spawns a WebGL Application whose teardown nukes Pixi's global
// shader cache mid-init for the second mount → render crashes. Production
// builds do not run StrictMode regardless.
ReactDOM.createRoot(rootEl).render(<App />);

// Tell index.html to fade out the pre-React splash as soon as React owns
// the screen. Defer one frame so the first paint is React, not blank.
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    window.__cdSplashDone?.();
    // Native: hide the OS-level splash too (Capacitor SplashScreen plugin).
    native.hideSplash();
  });
});
